// World-frame ground grid at Y=0. Visual anchor for pose-3d scenes.
// See ticket 891.

import * as THREE from 'three';
import { WebGLElement } from './base.js';

export class ThreeGroundGrid extends WebGLElement {
  static properties = {
    ...WebGLElement.properties,
    size:       { type: Number },
    divisions:  { type: Number },
    color:      { type: String },
    centerColor:{ type: String, attribute: 'center-color' },
  };

  constructor() {
    super();
    this.size = 10;
    this.divisions = 10;
    this.color = '#313244';
    this.centerColor = '#585b70';
  }

  createObject3D() {
    const grid = new THREE.GridHelper(
      this.size,
      this.divisions,
      new THREE.Color(this.centerColor),
      new THREE.Color(this.color),
    );
    grid.material.transparent = true;
    grid.material.opacity = 0.6;
    return grid;
  }

  updated(changed) {
    super.updated(changed);
    if (!this.object3D) return;
    if (changed.has('size') || changed.has('divisions')
        || changed.has('color') || changed.has('centerColor')) {
      // Cheapest path: recreate. GridHelper itself is light.
      const parent = this.object3D.parent;
      if (parent) parent.remove(this.object3D);
      this.object3D.geometry?.dispose();
      this.object3D.material?.dispose();
      const next = new THREE.GridHelper(
        this.size,
        this.divisions,
        new THREE.Color(this.centerColor),
        new THREE.Color(this.color),
      );
      next.material.transparent = true;
      next.material.opacity = 0.6;
      this.object3D = next;
      if (parent) parent.add(next);
    }
  }
}

customElements.define('three-ground-grid', ThreeGroundGrid);
